import React from "react";
import { Link } from "react-router-dom";
import Avatar from "../Avatar/Avatar";

const BlogCard = React.memo(({ blog, index, totalPosts }) => {
  return (
    <div className={`w-full mt-[50px] first:mt-0 ${index < totalPosts - 1 ? '' : ''}`}>
      <img src={blog.image} alt={blog.title} className="object-cover w-full" />
      
      <div className="flex flex-col sm:flex-row mt-5 gap-2 md:gap-[30px]">
        <div className="flex items-center gap-2.5">
          <Avatar
            src={blog.author_image}
            alt={blog.author}
            size="w-[30px] h-[30px]"
          />
          <p className="text-paragraph">{blog.author}</p>
        </div>
        <div className="flex items-center gap-2.5">
          <div className="w-[5px] aspect-square rounded-full bg-purple/20"></div>
          <p className="text-paragraph">{blog.date}</p>
        </div>
        {/* <div className="flex items-center gap-2.5">
          <div className="w-[5px] aspect-square rounded-full bg-purple/20"></div>
          <p className="text-paragraph">{blog.readTime}</p>
        </div> */}
      </div>
      
      <hr className="mt-5 border-purple/30" />
      
      <h1 className="text-24 sm:text-[30px] leading-[40px] tracking-tight text-white font-semibold mt-[30px]">
        {blog.title}
      </h1>
      
      <p className="text-paragraph mt-[22px] mb-[25px]">
        {blog.description}
      </p>
      
      {/* <div className="flex flex-wrap gap-2 mb-4">
        {blog.tags.map((tag, tagIndex) => (
          <span
            key={tagIndex}
            className="px-2 py-1 text-xs bg-purple/10 text-purple rounded-md"
          >
            {tag}
          </span>
        ))}
      </div> */}
      
      <Link to={`/blog/${blog.slug}`}>
        <div className="flex items-center gap-2 group relative">
          <p className="mb-[1px] font-medium text-paragraph leading-5 font-inter border-b border-transparent before:block before:pb-[1px] before:border-purple before:font-medium before:text-purple before:leading-5 before:font-inter before:border-b before:content-['Read More'] before:absolute before:-bottom-[1px] before:transition-all before:duration-300 before:w-0 hover:before:w-[80px] before:overflow-hidden before:h-[21px]">
            Read More
          </p>
          <svg
            width="7"
            height="11"
            viewBox="0 0 7 11"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              className="transition-all duration-300 delay-300 group-hover:stroke-purple group-hover:delay-0"
              d="M1.5 10L5.29289 6.20711C5.62623 5.87377 5.79289 5.70711 5.79289 5.5C5.79289 5.29289 5.62623 5.12623 5.29289 4.79289L1.5 1"
              stroke="#6D6D6D"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
      </Link>
    </div>
  );
});

BlogCard.displayName = 'BlogCard';

export default BlogCard;
